import React from 'react';

import { Page, Text, BlockStack, InlineGrid, Link, FooterHelp, useBreakpoints, Divider } from '@shopify/polaris';
import {
  OrderIcon,
  PackageIcon,
  ReturnIcon,
  BarcodeIcon,
  SettingsIcon,
  ClockIcon,
} from '@shopify/polaris-icons';

import FeatureCard from '../partials/FeatureCard';

import { UI_COLORS } from '../../constants';

const MainPage = () => {
  const { smUp } = useBreakpoints();

  return(
    <Page
      title="Pack Perfect"
      subtitle="Have questions or need some help? Contact us at support@athousandapps.com"
    >
      <BlockStack gap="500">
        <FeatureCard
          title="Convert Order Shipments"
          description="Prepare awaiting-fulfillment order shipments and convert them into warehouse picking totes."
          buttonText="Order Shipments"
          image={OrderIcon}
          linkUrl="/order_shipments"
          stripeBackground={UI_COLORS.cyan}
        />

        {smUp ? <Divider /> : null}

        <FeatureCard
          title="Active Batches"
          description="Review batches being picked and packed. See order shipments, carts and the totes inside them."
          buttonText="Active Batches"
          image={PackageIcon}
          linkUrl="/batches"
          stripeBackground='#4b71fc'
        />

        {smUp ? <Divider /> : null}

        <FeatureCard
          title="Completed Batches"
          description="Batches that have finished picking and packing. Actions can be taken for carts with items left on them."
          buttonText="Completed Batches"
          image={ReturnIcon}
          linkUrl="/returns"
          stripeBackground={UI_COLORS.danger}
        />

        {smUp ? <Divider /> : null}

        <FeatureCard
          title="Warehouse App"
          description="Pick, pack and process returns on the warehouse floor. Best experienced in the mobile app - also available here in the browser."
          buttonText="Warehouse App"
          image={BarcodeIcon}
          linkUrl="/warehouse"
          stripeBackground={UI_COLORS.accent}
        />

        {smUp ? <Divider /> : null}

        <FeatureCard
          title="App Settings"
          description="Manage app settings for Pack Perfect."
          buttonText="Settings"
          image={SettingsIcon}
          linkUrl="/settings"
          stripeBackground={UI_COLORS.danger}
        />

        {smUp ? <Divider /> : null}

        <FeatureCard
          title="History"
          description="Review recently completed batches and the audit log of warehouse and admin actions."
          buttonText="History"
          image={ClockIcon}
          linkUrl="/history"
          stripeBackground={UI_COLORS.success}
        />

        <FooterHelp>
          By using Pack Perfect, you acknowledge that you have read and agree to A Thousand Apps Inc.'s <Link url="https://athousandapps.com/terms-of-service/" external>Terms of Service</Link> and <Link url="https://athousandapps.com/privacy-policy/" external>Privacy Notice</Link>, both of which govern your use of this service.
        </FooterHelp>
      </BlockStack>
    </Page>
  )
}

export default MainPage;
